import {   FETCH_ACTIVE_SEASONS,SAVE_SEASON_OILCONDITIONS , TRIGGER_SEASON,RESET_OIL_SETTINGS } from '../../actions'

function getOilConditions(seasons){
       
        const seasonOil = {}
      
        seasons.map(function(season) {
            const { id,oilChallengeFrom,oilChallengeTo,oilStandardFrom,oilStandardTo,oilSportTo, isSeasonSet } = season
            const oil = {
                seasonId: id,
                challengeFrom: oilChallengeFrom ? oilChallengeFrom.toFixed(2): null,
                challengeTo:oilChallengeTo ? oilChallengeTo.toFixed(2): null,
                standardFrom:oilStandardFrom ? oilStandardFrom.toFixed(2): null,
                standardTo:oilStandardTo ? oilStandardTo.toFixed(2) : null,
                sportTo:oilSportTo ? oilSportTo.toFixed(2): null,
                isSeasonSet
            }
            seasonOil[id] = oil
        })
        return seasonOil
}

function getSingleOilConditions(season){
    const { id,oilChallengeFrom,oilChallengeTo,oilStandardFrom,oilStandardTo,oilSportTo } = season
    const oil = {
            seasonId: id,
            challengeFrom: oilChallengeFrom ? oilChallengeFrom.toFixed(2): null,
            challengeTo:oilChallengeTo ? oilChallengeTo.toFixed(2): null,
            standardFrom:oilStandardFrom ? oilStandardFrom.toFixed(2): null,
            standardTo:oilStandardTo ? oilStandardTo.toFixed(2) : null,
            sportTo:oilSportTo ? oilSportTo.toFixed(2): null,
            isSeasonSet:true
        }
      
    return oil
}
       
export default function seasonoil (state,action) {   
        const {  payload } = action      
        switch(action.type) {
          
            case FETCH_ACTIVE_SEASONS: {           
                const { data } = payload
                if (data) {                
                    const defaultId = payload.data[0].id
                    const oilConditions = getOilConditions(data)
                   
                    return Object.assign({},state,{
                            values: {
                                
                                conditions:oilConditions,
                                settingsseason:defaultId,
                                initialstate:oilConditions,
                                oilreset:false,
                               // datasaved:true
                            },
                            fields: {
                                conditions:oilConditions,
                                settingsseason:defaultId,
                                initialstate:oilConditions,
                                oilreset:false,
                               // datasaved:true
                            }
                        }
                    )
                }
                else {
                    return state
                }
            }
            case SAVE_SEASON_OILCONDITIONS: {
                const datasaved  = true 
                const savingdata = false
                return  { ...state, 
                    values: {
                             ...state.values,
                             savingdata,
                             datasaved,
                             initialstate:state.values.conditions         
                           },
                    fields: {
                             ...state.fields,
                             savingdata,
                             datasaved,
                             initialstate:state.fields.conditions
                           }
                 }
            }
            case TRIGGER_SEASON: {
                const seasontriggered = true 
                const isSettingSeason = false
                
                const oil  = getSingleOilConditions(payload.data)
               
                const seasonId = oil.seasonId
                const { conditions } = state.values
                conditions[seasonId] = oil
               
                return  { ...state, 
                   values: {
                             ...state.values ,
                             seasontriggered,
                             isSettingSeason ,
                             conditions:conditions ,                            
                           },
                   fields: {
                             ...state.fields,
                             seasontriggered,
                             isSettingSeason,
                             conditions:conditions
                           }
                 }
               
            }
            case RESET_OIL_SETTINGS:{
             
                const { initialstate } = state.values
                
                return  { ...state, 
                    values: {
                            ...state.values,
                            conditions:initialstate,
                            oilreset:true,
                            //datasaved:true
                           },
                    fields: {
                            ...state.fields,
                            conditions:initialstate,
                            oilreset:true,
                            //datasaved:true
                           }
                 }
            }
            default: return state
        }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/forms/seasonoil.js